import { Plus } from 'lucide-react';
import React from 'react';
import { Button, Tooltip, FormDrawer } from '../../ui';
import FormGroup from '../Forms/FormGroup';

export default function AddGroup(props: { handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        props.handleFunction()
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Ajouter un nouveau groupe">
                <Button
                    size='sm'
                    style={{ float: "right" }}
                    variant="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => setOpen(true)}
                >Ajouter</Button>
            </Tooltip>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Ajout d'un groupe utilisateur"
                hint="Définissez le libellé du groupe et les habilitations associées."
            >
                <FormGroup onSaved={handleClose} />
            </FormDrawer>
        </div>
    );
}
